var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8516 21.5845C12.1482 21.9503 12.74 21.7405 12.74 21.2695V2.41048C12.74 1.93949 12.1482 1.72973 11.8516 2.09556L7.50973 7.45002H1.78C1.34922 7.45002 1 7.79924 1 8.23002V15.43C1 15.8608 1.34922 16.21 1.78 16.21H7.49353L11.8516 21.5845Z",
    stroke: "#6C74B4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7568 1.88208C21.7828 4.68073 22.977 8.12089 22.977 11.84C22.977 15.5591 21.7828 18.9993 19.7568 21.7979M16.0463 5.30972C17.2676 7.18905 17.977 9.43167 17.977 11.84C17.977 14.2483 17.2676 16.4909 16.0463 18.3703",
    stroke: "#6C74B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio-icon.f2f601fd3811d90cf89f191a21f4af09.svg";
export { ForwardRef as ReactComponent };